<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section class="flex h-full w-full flex-col overflow-hidden bg-n-surface-1">
    <header
      class="sticky top-0 z-10 border-b border-n-weak bg-n-surface-1/95 px-4 backdrop-blur sm:px-6 lg:px-8"
    >
      <div class="mx-auto w-full max-w-6xl">
        <div class="flex h-20 w-full items-center justify-between gap-3">
          <span
            class="text-heading-1 font-semibold tracking-tight text-n-slate-12"
          >
            {{ headerTitle }}
          </span>
          <div class="relative group/campaign-button">
            <Button
              :label="buttonLabel"
              icon="i-lucide-plus"
              size="sm"
              class="group-hover/campaign-button:brightness-110"
              @click="handleButtonClick"
            />
            <slot name="action" />
          </div>
        </div>
      </div>
    </header>
    <main class="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-8">
      <div class="mx-auto w-full max-w-6xl py-6">
        <slot name="default" />
      </div>
    </main>
  </section>
</template>
